import wx from './wx-sdk';

function bindShare(config, callback) {
    wx.invoke('updateAppMessageShareData', config, res =>{
        callback({ type: 'appmessage' }, res);
    })
    wx.invoke('updateTimelineShareData', config, res =>{
        callback({ type: 'appmessage' }, res);
    })
}

/**
 * 把cofig的写法符合微信参数
 * @param config
 */
function formatConfig({ imgUrl, url, title, desc }) {
    return {
        img_url: imgUrl,
        imgUrl,
        img_width: '240',
        img_height: '240',
        link: url || location.href,
        desc: desc || document.title,
        title: title || document.title,
    };
}

export default function (config, callback) {
    let formattedCfg = formatConfig(config)
    wx.ready(function () { 
        bindShare(formattedCfg, callback);
    });
}
